import { rpcCall } from '@scayle/storefront-nuxt'
import type { CatalogOrderFormParams } from '~/rpcMethods'

export default () => {
  const currentShop = useCurrentShop()
  const nuxtApp = useNuxtApp()

  const fetching = ref(false)
  const data = ref()
  const error = ref()

  const fetch = async (params: CatalogOrderFormParams) => {
    error.value = null

    try {
      fetching.value = true

      const call = rpcCall(nuxtApp, 'catalogOrder', currentShop.value)

      data.value = await call({
        ...params,

        locale: currentShop.value.locale,
      })
    } catch (e) {
      error.value = e
    } finally {
      fetching.value = false
    }
  }

  return {
    fetch,
    fetching,
    data,
    error,
  }
}
